.container {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

.row,
.suggested {
  padding: var(--tuna-spacing-1);
  border-radius: var(--tuna-shape-borderRadius);
}

/* The top N are pre-highlighted so the ranking is visible, not just applied. */
.suggested {
  background: var(--tuna-palette-action-selected);
}

.label {
  display: inline-flex;
  align-items: baseline;
  gap: var(--tuna-spacing-2);
}

.tally {
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-body2-fontSize);
}

.maybe {
  color: var(--tuna-feedback-warning-text);
  font-size: var(--tuna-typography-body2-fontSize);
}

/*
 * The closed row needs its own box: `.row` above carries a FormControlLabel, whose checkbox
 * supplies the spacing between the control and its text. Without one, the date and the tally
 * were two adjacent inline spans with no whitespace between them and rendered as a single run —
 * `Sun 30 Aug, 19:001 of 1 available`, a digit fused to a time, which reads as a typo rather
 * than as two fields. Matches `.winner` on the Default closed page.
 */
.closedRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-1) 0;
}

.closedLabel {
  min-width: 10rem;
  color: var(--tuna-content-primary);
  font-size: var(--tuna-typography-body1-fontSize);
}

@media (max-width: 599.95px) {
  .closedRow {
    align-items: flex-start;
    flex-direction: column;
    gap: var(--tuna-spacing-1);
  }
}

.notice {
  color: var(--tuna-content-muted);
}

.counter {
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-body2-fontSize);
}
